export default __webpack_public_path__ + "files/249d03d271a38c75d7ce88e42d901fea.png";